import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useForgotPassword } from '../hooks/use-forgot-password';
import { AuthLayout } from '@react-apps/design-system';

export function ForgotPasswordPage() {
  const { forgotPassword, isLoading, error, success } = useForgotPassword();
  const [email, setEmail] = useState('');

  const handleSubmit = (e: { preventDefault(): void }) => {
    e.preventDefault();
    void forgotPassword(email);
  };

  return (
    <AuthLayout
      title="Esqueceu sua senha?"
      subtitle="Informe seu e-mail e enviaremos um link para redefinir sua senha"
    >
      {success ? (
        <div className="space-y-6">
          <div className="rounded-lg border border-green-200 bg-green-50 px-4 py-6 text-center dark:border-green-900 dark:bg-green-950">
            <svg
              className="mx-auto mb-3 h-8 w-8 text-green-600 dark:text-green-400"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth={1.5}
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M21.75 6.75v10.5a2.25 2.25 0 0 1-2.25 2.25h-15a2.25 2.25 0 0 1-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25m19.5 0v.243a2.25 2.25 0 0 1-1.07 1.916l-7.5 4.615a2.25 2.25 0 0 1-2.36 0L3.32 8.91a2.25 2.25 0 0 1-1.07-1.916V6.75"
              />
            </svg>
            <p className="text-sm font-medium text-green-700 dark:text-green-400">
              Link enviado! Verifique sua caixa de entrada.
            </p>
          </div>
          <Link
            to="/sign-in"
            className="bg-(--color-accent) flex w-full items-center justify-center rounded-lg px-4 py-2.5 text-sm font-semibold text-white transition hover:opacity-90"
          >
            Voltar para o login
          </Link>
        </div>
      ) : (
        <form onSubmit={handleSubmit} className="space-y-5">
          <div>
            <label
              htmlFor="email"
              className="text-(--color-text-primary) mb-1.5 block text-sm font-medium"
            >
              E-mail
            </label>
            <input
              id="email"
              type="email"
              required
              autoComplete="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="seu@email.com"
              className="border-(--color-border) bg-(--color-bg-secondary) text-(--color-text-primary) placeholder:text-(--color-text-secondary) focus:border-(--color-accent) focus:ring-(--color-accent)/20 w-full rounded-lg border px-3 py-2.5 text-sm outline-none transition focus:ring-2"
            />
          </div>

          {error && (
            <div className="rounded-lg border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-700 dark:border-red-900 dark:bg-red-950 dark:text-red-400">
              {error}
            </div>
          )}

          <button
            type="submit"
            disabled={isLoading || !email.trim()}
            className="bg-(--color-accent) w-full rounded-lg px-4 py-2.5 text-sm font-semibold text-white transition hover:opacity-90 disabled:cursor-not-allowed disabled:opacity-50"
          >
            {isLoading ? 'Enviando…' : 'Enviar link de redefinição'}
          </button>

          <p className="text-(--color-text-secondary) text-center text-sm">
            <Link
              to="/sign-in"
              className="text-(--color-accent) font-medium hover:underline"
            >
              ← Voltar para o login
            </Link>
          </p>
        </form>
      )}
    </AuthLayout>
  );
}
